var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M.001.001h16.997V17H.001V.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M3.002 16v-1h10.997v1H3.002zm5.997-3h-.693l-.028.029L8.25 13H8v-.25L3.742 8.493l.708-.705L8 11.337V.999h.999v10.299l3.541-3.542.708.707-4.249 4.249V13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBigIcon);
export default __webpack_public_path__ + "static/media/download-big-icon.1baba76e5635836e09224533919e8967.svg";
export { ForwardRef as ReactComponent };